<mat-list>
  @for (action of actions$ | async; track action) {
    <mat-list-item>
      <div mat-line>{{ action.title }}</div>
      <div mat-line>{{ action.subTitle }}</div>
      <div mat-line>{{action.actionId }}</div>
      @if (processing(action)) {
        <mat-progress-bar mat-line [value]="action.progress"></mat-progress-bar>
      }
    </mat-list-item>
  }
</mat-list>
